
export interface UndoableActionInterface {
    new (...args: any[]): UndoableAction;
}

export interface UndoableAction {
    execute(): Promise<any>;
    undo(): Promise<any>;
}

export const makeReverseClass = (mainActionClass: UndoableActionInterface): UndoableActionInterface=> {
    return class extends mainActionClass {
        execute(): Promise<any> {
            return super.undo();
        }
        undo(): Promise<any> {
            return super.execute();
        }
    }
}
